import React from 'react';
import { Link } from 'react-router-dom';
import { BiGridAlt } from 'react-icons/bi';
import { BsPersonFillGear, BsDatabaseFillGear, BsPeopleFill, BsFillKeyFill } from "react-icons/bs";
import { TbUserQuestion } from "react-icons/tb";
// import { CgMenuBoxed } from "react-icons/cg";
import { CiLogout } from "react-icons/ci";
import { IoClose } from 'react-icons/io5';
import './sidebar.css';
import logoGc from "../../../imgs/LogoGcDarkBg.png";
const Sidebar = ({ isActive, logout, closeSidebar }) => {
    return (
        <div className={`l-navbar ${isActive ? 'show' : ''}`} id="nav-bar">
            <nav className="nav">
                <div>
                    <button className="close-btn" onClick={closeSidebar}>
                        <IoClose className='nav_icon' />
                    </button>
                    <Link to="/dashboard" className="nav_logo">
                        <img src={logoGc} className='Logo-image-sidebar-admin' alt="logo-gecimmo" />
                    </Link>
                    <div className="nav_list">
                        <Link to="/dashboard" className="nav_link">
                            <BiGridAlt className='nav_icon' /> <span className="nav_name">Dashboard</span>
                        </Link>

                        <Link to="/dashboard/users" className="nav_link">
                            <BsPeopleFill className='nav_icon' /> <span className="nav_name">Utilisateurs</span>
                        </Link>

                        <Link to="/dashboard/db-change" className="nav_link">
                            <BsDatabaseFillGear className='nav_icon' /> <span className="nav_name">Database</span>
                        </Link>

                        <Link to="/dashboard/roles" className="nav_link">
                            <BsPersonFillGear className='nav_icon' /> <span className="nav_name">Roles</span>
                        </Link>

                        <Link to="/dashboard/permissions" className="nav_link">
                            <BsFillKeyFill className='nav_icon' /> <span className="nav_name">Permissions</span>
                        </Link>
                        <hr />
                        <Link to="/dashboard/questions" className="nav_link">
                            <TbUserQuestion className='nav_icon' /> <span className="nav_name">Questions</span>
                        </Link>
                        {/* <Link to="/dashboard/models" className="nav_link">
                            <CgMenuBoxed className='nav_icon' /> <span className="nav_name">models</span>
                        </Link> */}

                    </div>
                </div>
                <button className="logoutbtna bg-dark" onClick={logout}>
                    <CiLogout className='side_icon' /> <span className="btnLogout_text">Log Out</span>
                </button>
            </nav>
        </div>
    );
};

export default Sidebar;
